/**
 * Created on 2020/12/1.
 */
import CONST from '../config';
import { encryptAES, decryptAES } from '@/libs/encrypt';

// 判断是否是json字符串
const isJSON = (str) => {
  try {
    const obj = JSON.parse(str);
    return typeof obj === 'object' && obj;
  } catch (e) {
    return false;
  }
};

// 解密取出
export const decryptGetStorage = (key, type = 'session') => {
  const storage = type === 'session' ? sessionStorage : localStorage;
  let res = storage.getItem(key) || '';
  if (res) {
    res = decryptAES(res, CONST.$AES_KEY);
    if (isJSON(res)) {
      res = JSON.parse(res);
    }
  }
  return res;
};

// 加密保存
export const encryptSetStorage = (key, data, type = 'session') => {
  let originData = data;
  if (originData && originData instanceof Object) {
    originData = JSON.stringify(originData);
  }
  const storage = type === 'session' ? sessionStorage : localStorage;
  storage.setItem(key, encryptAES(originData, CONST.$AES_KEY));
};

// 删除
export const removeStorage = (key, type = 'session') => {
  const storage = type === 'session' ? sessionStorage : localStorage;
  if (storage.getItem(key)) {
    storage.removeItem(key);
  }
};
